import ReactGA from "react-ga4";
ReactGA.initialize("G-8LHSLNP4P1");

const signup = (utmData) => {
    ReactGA.event("sign_up", { method: utmData });
};
const mailinglistsignup = (utmData) => {
    ReactGA.event("mailing_list_sign_up", { method: utmData });
};
const mailinglistsignupstage2 = (utmData) => {
    ReactGA.event("mailing_list_sign_up_stage_2", { method: utmData });
};
const purchase = (
    transactionId,
    price,
    currency,
    discountCode,
    productId,
    productName,
    utm
) => {
    ReactGA.event("purchase", {
        transaction_id: transactionId,
        value: price,
        currency: currency,
        coupon: discountCode,
        items: [
            {
                item_id: productId,
                item_name: productName,
                location_id: utm,
                price: price,
                quantity: 1,
            },
        ],
    });
};

const generic = (category, action, label) => {
    ReactGA.event({
        category: category,
        action: action,
        label: label,
    });
};

const gaEvents = {
    eventGeneric: generic,
    eventSignup: signup,
    mailingListSignup: mailinglistsignup,
    mailingListSignupStage2: mailinglistsignupstage2,
    eventPurchase: purchase,
};

export { gaEvents };
